import ReactTagInput from "@pathofdev/react-tag-input";
import {
  Button,
  Input,
  TableCell,
  TableContainer,
  TableHeader,
  Textarea,
  Table,
} from "@windmill/react-ui";
import Multiselect from "multiselect-react-dropdown";
import React from "react";
import { useEffect, useState, useContext } from "react";
import { SidebarContext } from "context/SidebarContext";

import { useForm } from "react-hook-form";
import { notifyError, notifySuccess } from "utils/toast";
import { Scrollbars } from "react-custom-scrollbars-2";
import { MultiSelect } from "react-multi-select-component";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FiX } from "react-icons/fi";
import UploaderThree from "components/image-uploader/UploaderThree";
import RichTextEditor from "components/form/RichTextEditor";
import Title from "components/form/Title";
import SwitchToggleForCombination from "components/form/SwitchToggleForCombination";
import ActiveButton from "components/form/ActiveButton";
import LabelArea from "components/form/LabelArea";
import Error from "components/form/Error";
import Uploader from "components/image-uploader/Uploader";
import InputArea from "components/form/InputArea";
import ParentCategory from "components/category/ParentCategory";
import InputValue from "components/form/InputValue";
import InputValueFive from "components/form/InputValueFive";
import AttributeOptionTwo from "components/attribute/AttributeOptionTwo";
import DrawerButton from "components/form/DrawerButton";
import AttributeListTable from "components/attribute/AttributeListTable";
import { showingTranslateValue } from "utils/translate";
import SubscriberServices from "services/SubscriberServices";
import SidebarContent from "components/sidebar/SidebarContent";
import ReferencesServices from "services/ReferencesServices";
import useReferenceSubmit from "hooks/useReferenceSubmit";
import DepartmentContactServices from "services/DepartementContactServices";
//internal import

const ContactDrawer = ({ id, data, isLoading, setIsLoading, isCheck, setIsCheck }) => {
  const { t } = useTranslation();


  const {
    register,
    errors,
    openModal,
    onCloseModal,
    isSubmitting,
    handleSelectImage,
  } = useReferenceSubmit(id, data);

  // closeDrawer();
  const { closeDrawer } = useContext(SidebarContext)

  const [imageUrl, setImageUrl] = useState("");
  const [oldImageUrl, setOldImageUrl] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [imagePhoto, setImagePhoto] = useState("");
  const handleImageChange = (e) => {
    const selectedFile = e.target.files[0];

    // Mettez à jour l'état avec le nom du fichier
    setImageUrl(selectedFile ? selectedFile : null);
    setImagePhoto(URL.createObjectURL(e.target.files[0]))

  };

  const {
    setValue,

  } = useForm();
  const [retsData, setRestData] = useState({});




  const handleSubmit = async (e) => {
    e.preventDefault();

    const Error = ({ errorName }) => {
      return (
        <div className="text-red-500 text-sm mt-1">{errorName && errorName.message}</div>
      );
    };

    const formData = new FormData();
    formData.append('subject', subject);
    formData.append('message', message);
    


    
      try {

        const filteredIsCheck = isCheck.filter(contactId => contactId !== 'selectAll' && contactId !== 'f' );

      
        setIsLoading(true);
         
          formData.append('contact_id', filteredIsCheck);

    
          // Send a request to store the message for the current subscriber
          const response=await DepartmentContactServices.sendMail(formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
            withCredentials: true,
          });
    
         
        setIsLoading(false);
    
        closeDrawer();

        setIsCheck([]);

        notifySuccess(response.message);

        setSubject("");
        setMessage("");
       

      } catch (error) {
        // console.error("Erreur lors d'ajout d'une référence", error);
        const errorMessage = "Erreur lors de l'envoi du courriel : " + error;
        notifyError(errorMessage);
      } 
    
  };
 
 




  return (
    <>
      <Modal
        open={openModal}
        onClose={onCloseModal}
        center
        closeIcon={
          <div className="absolute top-0 right-0 text-red-500 focus:outline-none active:outline-none text-xl border-0">
            <FiX className="text-3xl" />
          </div>
        }
      >
        <div className="cursor-pointer">
          <UploaderThree
            imageUrl={imageUrl}
            setImageUrl={setImageUrl}
            handleSelectImage={handleSelectImage}
          />
        </div>
      </Modal>

      <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
       
          <Title
            register={register}
            // handleSelectLanguage={handleSelectLanguage}
            title={"Send mail"}
            description={"Send mail"}
            required={true}
          />
    
      </div>


      <Scrollbars className="track-horizontal thumb-horizontal w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">
        <form onSubmit={handleSubmit} className="block" id="block">

          <div className="px-6 pt-8 flex-grow w-full h-full max-h-full pb-40 md:pb-32 lg:pb-32 xl:pb-32">





            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea label={" Subject "} />
              <div className="col-span-8 sm:col-span-4">
                <Input
                  className="border h-12 text-sm focus:outline-none block w-full bg-gray-100 dark:bg-white border-transparent focus:bg-white"
                  name="subject"
                  type="text"
                  placeholder={" Subject "}
                  // onBlur={(e) => handleProductSlug(e.target.value)}
                  value={subject}
                  
                  onChange={(e) => setSubject(e.target.value)}
                  required={true}
                />
                <Error errorName={errors.subject} />
              </div>
            </div>
            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea label={ " Message "} />
              <div className="col-span-8 sm:col-span-4">
                <RichTextEditor
                  placeholder={" Message "}
                  value={message}
                  onChange={(content) => setMessage(content)}
                />
                <Error errorName={errors.message} />
              </div>
            </div>
          </div>
          <DrawerButton id={id} title="Submit" isSubmitting={isSubmitting} />


         
        </form>


      </Scrollbars>




    </>
  );
};

export default React.memo(ContactDrawer);
